/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .organizational-unit-tree {
    background: #ffffff;

    svg {
      .rd3t-node,
      .rd3t-leaf-node {
        transition: all 0.5s ease-in-out;
      }
    }
  }

  .organizational-unit-tree-node {
    padding-top: 500px;
    font-family: ${$.primaryMain};

    > foreignObject {
      > div {
        border: 1px solid black;
        background-color: ${$.white};
        border-radius: 5px;

        > .type {
          padding: 0 5px;
          font-size: 0.8rem;
          background-color: ${$.primaryMain};
          color: ${$.white};
        }

        > .body {
          padding: 5px 5px;
          min-height: 3em;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #e7e7e7cc;

          > h3 {
            text-align: center;
            margin: 0;
            font-size: 14px;
            font-family: ${$.fontFamily};
          }
        }

        > .buttons {
          display: flex;
          justify-content: stretch;
          background: #e7e7e7cc;

          > button {
            flex-grow: 1;
            font-size: 12px;
          }

          > :not(:first-of-type) {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }

          > :not(:last-child) {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
      }
    }
  }
`;
